import { WsPath } from '@bangle.io/ws-path';
import {
  GETTING_STARTED_FILE_NAME,
  GETTING_STARTED_MARKDOWN,
} from './getting-started-content';

type GettingStartedFileSystem = {
  exists(wsPath: string): Promise<boolean>;
  createTextFile(wsPath: string, text: string): Promise<void>;
};

/**
 * Ensures `Getting Started.md` exists in the workspace and returns its wsPath.
 * Skips writing when the path already exists (e.g. a Native FS folder that
 * already has this file) so create never overwrites user content.
 */
export async function seedGettingStartedNote(
  fileSystem: GettingStartedFileSystem,
  wsName: string,
): Promise<string> {
  const wsPath = WsPath.fromParts(wsName, GETTING_STARTED_FILE_NAME).wsPath;

  if (!(await fileSystem.exists(wsPath))) {
    await fileSystem.createTextFile(wsPath, GETTING_STARTED_MARKDOWN);
  }

  return wsPath;
}
